module.exports = {"id":"dp4_2l3q6","text":"Protecting personal data and privacy","instructions":"Which tool helps manage privacy across multiple digital services?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":true,"options":[{"id":"dp4_2l3q6-a1","text":"Privacy settings dashboards","score":3.7},{"id":"dp4_2l3q6-a2","text":"Graphic design tools","score":1.3},{"id":"dp4_2l3q6-a3","text":"Spreadsheet software","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l3q6.json
// module id = 1233
// module chunks = 41